import { css } from '@emotion/react';
import styled from '@emotion/styled';
import { FlexStack } from '~/components/atomic';

export default function CharacterDetailsSkeleton() {
  return (
    <>
      <Container>
        <FlexStack spacing={32}>
          <FlexStack spacing={16}>
            <Image />
            <FlexStack spacing={10}>
              <Name />
              <FlexStack
                spacing={0}
                direction='row'
                css={css`
                  gap: 16px;
                `}
              >
                <Desc1 />
                <Desc2 />
              </FlexStack>
            </FlexStack>
          </FlexStack>
          <FlexStack spacing={32}>
            <FlexStack direction='column' spacing={10}>
              <SectionTitle />
              <Text />
              <Text />
              <Text />
              <Text />
            </FlexStack>
            <Divider />
            <FlexStack direction='column' spacing={10}>
              <SectionTitle />
              <Text />
              <Text />
              <Text />
              <Text />
            </FlexStack>
            <Divider />
            <FlexStack direction='column' spacing={10}>
              <SectionTitle />
              <Text />
              <Text />
              <Text />
              <Text />
            </FlexStack>
          </FlexStack>
        </FlexStack>
      </Container>
    </>
  );
}

export const Container = styled.div`
  ${({ theme }) => css`
    display: flex;
    position: relative;
    flex-direction: column;
    width: 100%;
    min-height: 100%;
    padding: ${theme.layout.chat_header_height} ${theme.layout.section_side}
      calc(${theme.layout.chat_navigation_height} + 30px);
  `}
`;

export const Image = styled.div`
  ${({ theme }) => css`
    position: relative;
    overflow: hidden;
    border-radius: 4px;
    ${theme.mixins.aspectRatio.ratio1_1};
    background: ${theme.backgroundColor.bg_dark_2};
  `}
`;

export const Name = styled.div`
  ${({ theme }) => css`
    width: 100px;
    height: 25px;
    border-radius: 24px;
    background: ${theme.backgroundColor.bg_dark_2};
  `}
`;

export const Desc1 = styled.div`
  ${({ theme }) => css`
    width: 30px;
    height: 20px;
    border-radius: 24px;
    background: ${theme.backgroundColor.bg_dark_2};
  `}
`;

export const Desc2 = styled.div`
  ${({ theme }) => css`
    width: 50px;
    height: 20px;
    border-radius: 24px;
    background: ${theme.backgroundColor.bg_dark_2};
  `}
`;

export const SectionTitle = styled.div`
  ${({ theme }) => css`
    width: 100px;
    height: 14px;
    padding: 3px 0;
    border-radius: 24px;
    background: ${theme.backgroundColor.bg_dark_2};
  `}
`;

export const Text = styled.div`
  ${({ theme }) => css`
    display: block;
    width: 100%;
    height: 16px;
    padding: 3px 0;
    border-radius: 24px;
    background: ${theme.backgroundColor.bg_dark_2};
  `}
`;

export const Divider = styled.div`
  ${({ theme }) => css`
    width: 100%;
    height: 1px;
    background: ${theme.stroke.stroke_1};
  `}
`;
